import { useState, useEffect } from "react";
import { X, Lightbulb } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

interface PageTipProps {
  pageKey: string;
  message: string;
}

export function PageTip({ pageKey, message }: PageTipProps) {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user) return;
    const userRef = doc(db, "users", user.uid);
    getDoc(userRef).then((snap) => {
      const data = snap.data();
      const dismissed = data?.dismissedTips || [];
      if (!dismissed.includes(pageKey)) {
        setVisible(true);
      }
    }).catch(console.error);
  }, [user, pageKey]);

  const dismiss = async () => {
    setVisible(false);
    if (!user) return;
    try {
      const userRef = doc(db, "users", user.uid);
      const snap = await getDoc(userRef);
      const dismissed = snap.data()?.dismissedTips || [];
      if (!dismissed.includes(pageKey)) {
        await setDoc(userRef, { dismissedTips: [...dismissed, pageKey] }, { merge: true });
      }
    } catch (err) {
      console.error("Failed to save tip dismissal:", err);
    }
  };

  if (!visible) return null;

  return (
    <div className="flex items-start gap-3 p-4 rounded-lg bg-primary/5 border border-primary/15 text-sm">
      <Lightbulb className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
      <p className="flex-1 text-muted-foreground leading-relaxed">{message}</p>
      <button onClick={dismiss} className="p-0.5 rounded hover:bg-muted flex-shrink-0">
        <X className="h-4 w-4 text-muted-foreground" />
      </button>
    </div>
  );
}
